import { Injectable, Inject, Optional } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";

import { CommonService } from "./common.service";
import { MessageService } from "./message.service";

import { environment } from "../../environments/environment";

@Injectable()
export class YoyakuService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) {}

  private httpOptions = this.commonService.httpOptions;
  private Options = this.commonService.Options;

  /***** 管理者 *****/
  //予約カレンダー取得
  getYoyakuAdminCalenderList(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/yoyakuhyo/yoyakuhyo_calenderlist_all/" +
          param.t_yoyakuhyo_id +
          "/",
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(
          this.commonService.handleError("yoyakuadmincalender_list", [])
        )
      );
  }
  //予約カレンダー取得（予約表一覧）
  getYoyakuhyoAdmin(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl + "/api/yoyakuhyo/yoyakuhyo_all/" + param.eid,
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("yoyakuhyo", []))
      );
  }
  //予約カレンダー取得（予約表一覧）
  getYoyakuPerson(param: number) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl + "/api/yoyakuhyo/yoyaku_person_list/" + param,
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("yoyakuhyo", []))
      );
  }
  //予約情報の保存
  saveYoyakuData(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/yoyakuhyo/save", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("saveYoyaku", []))
      );
  }
  //予約情報の削除
  deleteYoyakuData(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/yoyakuhyo/delete", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("deleteYoyaku", []))
      );
  }
  //予約表の一括作成
  createYoyakuLump(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/yoyakuhyo/create_yoyaku", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("saveYoyaku", []))
      );
  }
  //予約表の一括削除
  deleteYoyakuLump(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/yoyakuhyo/delete_yoyakudata", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("saveYoyaku", []))
      );
  }
  //予約表の保存
  saveYoyakuhyo(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/yoyakuhyo/saveyoyakuhyo",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("saveYoyakuhyo", []))
      );
  }
  //予約表をイベントに紐づける
  setYoyaku(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/yoyakuhyo/setyoyakuhyo",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("setyoyakuhyo", []))
      );
  }
  //予約表削除
  deleteYoyaku(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/yoyakuhyo/deleteyoyakuhyo",
        param,
        this.Options
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("deleteyoyakuhyo", []))
      );
  }
  //受検者一覧より予約メモ保存
  saveMemo(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/yoyaku/saveMemo", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("saveYoyaku", []))
      );
  }
  //受検者一覧より予約メモ保存
  outputYoyakulistExcel(param: any) {
    this.commonService.get_file(
      environment.apiUrl + "/api/output/yoyakulist/yoyakulist_excel",
      param
    );
  }
  /***** ユーザー *****/
  //予約カレンダー取得
  getYoyakuCalenderList(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/yoyaku/yoyakucalender_list_all/" +
          param.t_person_id +
          "/" +
          param.t_yoyakuhyo_id +
          "/" +
          param.m_language_id +
          "/" +
          param.m_division_1_id +
          "/" +
          param.m_division_2_id,
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("yoyakucalender_list", []))
      );
  }
  //予約保存
  saveYoyaku(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/yoyaku/save", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("saveYoyaku", []))
      );
  }
  //予約受付
  acceptYoyaku(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/yoyaku/acceptyoyaku/" +
          param.t_person_id +
          "/" +
          param.t_yoyaku_id +
          "/2",
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("yoyakucalender_list", []))
      );
  }
  //予約キャンセル
  cancelYoyaku(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/yoyaku/cancel", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("cancelYoyaku", []))
      );
  }
  //予約受付取り消し
  acceptYoyakuCancel(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/yoyaku/acceptyoyaku_cancel/" +
          param.t_person_id +
          "/" +
          param.t_yoyaku_id +
          "/2",
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("yoyakucalender_list", []))
      );
  }
    //予約受付一覧取得
    getYoyakuAcceptList() {
      this.commonService.loadingStart();
      return this.http
        .get(
          environment.apiUrl + "/api/yoyaku/yoyaku_accept_all",this.httpOptions)
        .pipe(
          tap((Response) => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError("yoyakuhyo", []))
        );
    }
    // ★関学聖和対応
    // 聖和キャンパスカスタマイズ（ユーザー画面取得処理）
    getCustomize38(mYoyakuhyoId: any, mYoyakuId: any) {
      this.commonService.loadingStart();
      return this.http
        .get(
          environment.apiUrl + "/api/yoyaku/yoyaku_question_seiwa/" + mYoyakuhyoId + "/" + mYoyakuId,this.httpOptions)
        .pipe(
          tap((Response) => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError("yoyakuhyo", []))
        );
    }
    //聖和キャンパスカスタマイズ（管理者画面取得処理）
    getAdminCustomize38(mYoyakuhyoId: any) {
      this.commonService.loadingStart();
      return this.http
        .get(
          environment.apiUrl + "/api/yoyaku/admin_yoyaku_question_seiwa/" + mYoyakuhyoId,this.httpOptions)
        .pipe(
          tap((Response) => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError("yoyakuhyo", []))
        );
    }
    //聖和キャンパスカスタマイズ（管理者画面登録処理）
    saveCustomize38(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(
        environment.apiUrl + "/api/yoyaku/admin_save_seiwa/", param, this.Options)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("yoyakuhyo", []))
      );
    }
    //予約受付一覧取得
    getYoyakuQrCheck(tpId:any, tyId:any) {
      this.commonService.loadingStart();
      return this.http
        .get(
          environment.apiUrl + "/api/yoyaku/qrcode_exists_check/" + tpId + "/" + tyId + "/1",this.httpOptions)
        .pipe(
          tap((Response) => this.commonService.loadingEnd()),
          catchError(this.commonService.handleError("yoyakuhyo", []))
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/service/yoyaku.service.ts